/**
 * @param {string} str text
 * */
export const isNumeric = (str) => {

  if (typeof str !== "string") return false

  return !isNaN(str) &&
    !isNaN(parseFloat(str))
}

export const checkCnpjIsValid = (value) => {
  const cleanValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (cleanValue.length !== 14) return false

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  const getWeight = (char) => {
    const code = char.charCodeAt(0)
    return code >= 48 && code <= 57 ? code - 48 : code - 48
  }

  const digits = Array.from(cleanValue).map(getWeight)

  const calculateDigit = (slice, weights) => {
    const sum = slice.reduce((acc, curr, idx) => acc + curr * weights[idx], 0)
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  const dv1 = calculateDigit(digits.slice(0, 12), weights1)
  const dv2 = calculateDigit(digits.slice(0, 13), weights2)

  return dv1 === digits[12] && dv2 === digits[13]
}
